const z = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function b(n) {
  return typeof n == "object" && n !== null && n.constructor && Object.prototype.toString.call(n).slice(8, -1) === "Object" && !n.__swiper__;
}
function j(n, i) {
  const r = ["__proto__", "constructor", "prototype"];
  Object.keys(i).filter((e) => r.indexOf(e) < 0).forEach((e) => {
    typeof n[e] > "u" ? n[e] = i[e] : b(i[e]) && b(n[e]) && Object.keys(i[e]).length > 0 ? i[e].__swiper__ ? n[e] = i[e] : j(n[e], i[e]) : n[e] = i[e];
  });
}
function M(n) {
  return n === void 0 && (n = {}), n.navigation && typeof n.navigation.nextEl > "u" && typeof n.navigation.prevEl > "u";
}
function B(n) {
  return n === void 0 && (n = {}), n.pagination && typeof n.pagination.el > "u";
}
function I(n) {
  return n === void 0 && (n = {}), n.scrollbar && typeof n.scrollbar.el > "u";
}
function L(n) {
  n === void 0 && (n = "");
  const i = n.split(" ").map((e) => e.trim()).filter((e) => !!e), r = [];
  return i.forEach((e) => {
    r.indexOf(e) < 0 && r.push(e);
  }), r.join(" ");
}
function N(n) {
  return n === void 0 && (n = ""), n ? n.includes("swiper-wrapper") ? n : `swiper-wrapper ${n}` : "swiper-wrapper";
}
function A(n) {
  let {
    swiper: i,
    slides: r,
    passedParams: e,
    changedParams: o,
    nextEl: s,
    prevEl: a,
    scrollbarEl: d,
    paginationEl: c
  } = n;
  const h = o.filter((t) => t !== "children" && t !== "direction" && t !== "wrapperClass"), {
    params: l,
    pagination: p,
    navigation: f,
    scrollbar: v,
    virtual: u,
    thumbs: E
  } = i;
  let S, _, x, C, P, m, O, g;
  o.includes("thumbs") && e.thumbs && e.thumbs.swiper && l.thumbs && !l.thumbs.swiper && (S = !0), o.includes("controller") && e.controller && e.controller.control && l.controller && !l.controller.control && (_ = !0), o.includes("pagination") && e.pagination && (e.pagination.el || c) && (l.pagination || l.pagination === !1) && p && !p.el && (x = !0), o.includes("scrollbar") && e.scrollbar && (e.scrollbar.el || d) && (l.scrollbar || l.scrollbar === !1) && v && !v.el && (C = !0), o.includes("navigation") && e.navigation && (e.navigation.prevEl || a) && (e.navigation.nextEl || s) && (l.navigation || l.navigation === !1) && f && !f.prevEl && !f.nextEl && (P = !0);
  const T = (t) => {
    i[t] && (i[t].destroy(), t === "navigation" ? (i.isElement && (i[t].prevEl.remove(), i[t].nextEl.remove()), l[t].prevEl = void 0, l[t].nextEl = void 0, i[t].prevEl = void 0, i[t].nextEl = void 0) : (i.isElement && i[t].el.remove(), l[t].el = void 0, i[t].el = void 0));
  };
  o.includes("loop") && i.isElement && (l.loop && !e.loop ? m = !0 : !l.loop && e.loop ? O = !0 : g = !0), h.forEach((t) => {
    if (b(l[t]) && b(e[t]))
      Object.assign(l[t], e[t]), (t === "navigation" || t === "pagination" || t === "scrollbar") && "enabled" in e[t] && !e[t].enabled && T(t);
    else {
      const w = e[t];
      (w === !0 || w === !1) && (t === "navigation" || t === "pagination" || t === "scrollbar") ? w === !1 && T(t) : l[t] = e[t];
    }
  }), h.includes("controller") && !_ && i.controller && i.controller.control && l.controller && l.controller.control && (i.controller.control = l.controller.control), o.includes("children") && r && u && l.virtual.enabled ? (u.slides = r, u.update(!0)) : o.includes("virtual") && u && l.virtual.enabled && (r && (u.slides = r), u.update(!0)), o.includes("children") && r && l.loop && (g = !0), S && E.init() && E.update(!0), _ && (i.controller.control = l.controller.control), x && (i.isElement && (!c || typeof c == "string") && (c = document.createElement("div"), c.classList.add("swiper-pagination"), c.part.add("pagination"), i.el.appendChild(c)), c && (l.pagination.el = c), p.init(), p.render(), p.update()), C && (i.isElement && (!d || typeof d == "string") && (d = document.createElement("div"), d.classList.add("swiper-scrollbar"), d.part.add("scrollbar"), i.el.appendChild(d)), d && (l.scrollbar.el = d), v.init(), v.updateSize(), v.setTranslate()), P && (i.isElement && ((!s || typeof s == "string") && (s = document.createElement("div"), s.classList.add("swiper-button-next"), s.innerHTML = i.hostEl.constructor.nextButtonSvg, s.part.add("button-next"), i.el.appendChild(s)), (!a || typeof a == "string") && (a = document.createElement("div"), a.classList.add("swiper-button-prev"), a.innerHTML = i.hostEl.constructor.prevButtonSvg, a.part.add("button-prev"), i.el.appendChild(a))), s && (l.navigation.nextEl = s), a && (l.navigation.prevEl = a), f.init(), f.update()), o.includes("allowSlideNext") && (i.allowSlideNext = e.allowSlideNext), o.includes("allowSlidePrev") && (i.allowSlidePrev = e.allowSlidePrev), o.includes("direction") && i.changeDirection(e.direction, !1), (m || g) && i.loopDestroy(), (O || g) && i.loopCreate(), i.update();
}
export {
  B as a,
  I as b,
  L as d,
  j as e,
  b as i,
  M as n,
  z as p,
  A as u,
  N as w
};
//# sourceMappingURL=update-swiper.mjs.map
